import React, { Component } from "react";
//import TableComp from '../../../../components/_utils/table'
import { TableComp } from "sz-react-utils";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";

import {
  Button,
  Card,
  Col,
  notification,
  Popconfirm,
  Row,
  Tooltip,
  Switch,
} from "antd";
import Request from "../../../../request";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import styles from "../../country/all/styles.less";

import rightAuth from "../../../../components/_utils/userRights";
import { RightsWrapper } from "../../../../components/_utils/utils";

class AllSubAgent extends Component {
  state = {
    count: 0,
    exportLoading: false,
  };

  constructor(props) {
    super(props);

    this.table = React.createRef();
  }

  exportExcel = async () => {
    const { exportParams } = this.state;

    this.setState({ exportLoading: true });
    let x = await Request.exportBranchesToExcel({
      ...exportParams,
      regExFilters: ["branchName"],
    });
    this.setState({ exportLoading: false });

    if (!x.error) {
      window.open(x.url);
    }
  };

  changeBranchStatus = async ({ checked, _id }) => {
    await Request.changeBranchStatus({
      _id,
      status: checked,
    });
    this.table.current.reload();
  };

  changeBranchRightTOViewChannelPartner = async ({ checked, _id }) => {
    await Request.changeBranchRightTOViewChannelPartner({
      _id,
      showChannelPartner: checked,
    });
    this.table.current.reload();
  }
  changeBranchRightTOShowStaffToOtherBranch = async ({ checked, _id }) => {
    await Request.changeBranchRightTOShowStaffToOtherBranch({
      _id,
      showStaffToOtherBranch: checked,
    });
    this.table.current.reload();
  }

  apiRequest = (params) => {
    return new Promise(async (resolve) => {
      this.setState({ exportParams: params });
      params.branchAssociatePartner = "Associate Partner"
      let data = await Request.loadBranch({
        ...params,
        regExFilters: ["branchName"],
      });

      this.setState({ count: data.total });

      resolve(data);
    });
  };

  componentDidMount() { }

  renderStatus = (val) => {
    if (val) {
      return <div className={styles.Potential}>YES</div>;
    } else {
      return <div className={styles.Cold}>NO</div>;
    }
  };

  handleDelete = (val) => {
    Request.deleteBranch(val)
      .then((x) => {
        if (x.success) {
          notification.success({
            message: x.msg,
            description: x.msg,
          });
        } else {
          notification.error({
            message: "Error",
            description: x.msg,
          });
        }
        this.table.current.reload();
      })
      .catch((err) => {
        notification.error({
          message: "Error",
          description: "Some Error",
        });
      });
  };

  render() {
    // const associatePartnerPlans = [
    //   { value: "Bronze", label: "Bronze" },
    //   { value: "Silver", label: "Silver" },
    //   { value: "Gold", label: "Gold" },
    //   { value: "Diamond", label: "Diamond" },
    // ];

    const branchType = [
      { value: "Branch", label: "Branch" },
      { value: "Associate Partner", label: "Associate Partner" },
    ];

    const columns = [
      {
        title: "Agent",
        key: "branchName",
        dataIndex: "branchName",
        width: 100,
        fixed: "left",
        sorter: true,
        searchTextName: "agentName",
        filterRegex: true,
        render: (val, record) => {
          return <React.Fragment>
            {rightAuth.checkRights("Branch.edit") ? <RightsWrapper myRight={"Branch.edit"}>
              <Tooltip title="Click To Edit Details">
                <a href={`/master/edit-subAgent?_id=${record._id}`}>
                  {record.branchName}
                </a>
              </Tooltip>
            </RightsWrapper> : <React.Fragment>
              {record.branchName}
            </React.Fragment>}
          </React.Fragment>;
        },
      },

      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: 70,
        render: (val, record) => {
          return (
            <div className={styles.wrap}>
              <Switch
                checked={record.status}
                onChange={(checked) => {
                  this.changeBranchStatus({
                    checked,
                    _id: record._id,
                  });
                }}
              />
            </div>
          );
        },
      },

      {
        title: "City",
        key: "city",
        width: 80,
        dataIndex: "city",
        render: (val, record) => {
          return (
            <div>{record.branchCityId ? record.branchCityId.cityName : ""}</div>
          );
        },
      },
      // {
      //   title: "Plan",
      //   key: "plan",
      //   width: 80,
      //   dataIndex: "plan",
      //   render: (val, record) => {
      //     return (
      //       <div>{record.plan ? record.plan.planName : ""}</div>
      //     );
      //   },
      // },
      {
        title: "State",
        key: "state",
        width: 80,
        dataIndex: "state",
        render: (val, record) => {
          return (
            <div>
              {record.branchStateId ? record.branchStateId.stateName : ""}
            </div>
          );
        },
      },
      {
        title: "Country",
        key: "country",
        width: 80,
        dataIndex: "country",
        render: (val, record) => {
          return (
            <div>
              {record.branchCountryId ? record.branchCountryId.countryName : ""}
            </div>
          );
        },
      },
      {
        title: "Agent Phone",
        key: "branchHeadPhone",
        dataIndex: "branchHeadPhone",
        render: (val, record) => {
          return (
            <div>
              <small>Head:{record.branchHeadPhone}</small>
              <div />
              <small>Branch:{record.branchPhone1}</small>
            </div>
          );
        },
      },
      {
        title: "Agent Email",
        key: "branchHeadEmail",
        dataIndex: "branchHeadEmail",
      },
      {
        title: "Action",
        key: "operation",
        width: 100,
        render: (text, record) => (
          <React.Fragment>
            <RightsWrapper myRight={"Branch.delete"}>
              <Tooltip title="Delete Branch">
                <Popconfirm
                  title="Are you sure to delete Branch?"
                  onConfirm={() => this.handleDelete(record._id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button shape="circle" className={styles.btn} icon="delete" />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        ),
      },
    ];
    return (
      <PageHeaderWrapper title={`Total Sub Agents : ${this.state.count}`}>
        <Card style={{ marginBottom: 10 }}>
          <Row>
            <Col span={12}>
              <Button
                type={"default"}
                loading={this.state.exportLoading}
                onClick={() => {
                  this.exportExcel();
                }}
              >
                Export Excel
              </Button>
            </Col>
            <Col span={10}>
            </Col>
            <Col span={2}>
              <div style={{ textAlign: 'right', marginTop: '15px' }}>
                <Link to='/master/add-subAgent'><Button>Add</Button></Link>
              </div>
            </Col>
          </Row>
        </Card>
        <Card bordered={true}>
          <TableComp
            columns={columns}
            ref={this.table}
            apiRequest={this.apiRequest}
            extraProps={{ scroll: { x: 1200 } }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 20,
              pageSizeOptions: ["10", "20", "50", "100", "1000"],
            }}
          />
        </Card>
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global }) => ({
  categories: global.categories,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllSubAgent);
